import React, { useRef, useState } from "react";
import { Form, Input } from "antd";
import styles from "./ChangePassword.scss";
import { requireUserLogin } from "../../routes/Auth/HOCs";
import { submitFormData } from "../../HOCs";
import LeftMenu from "../../components/LeftMenu";
import { updatePassword } from "../../routes/Auth/auth.ducks";
import HelmetComponent from "../../utils/HelmetHelper";
import { Button } from "../../components/Button/Button";

const passwordMinLength = 6;

const ChangePassword = props => {
  const {
    match: { path },
    form: { getFieldDecorator }
  } = props;

  const [confirmDirty, setConfirmDirty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 }
    },
    wrapperCol: {
      xs: { span: 24 }
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    setIsLoading(prev => !prev);

    props.form.validateFields((error, values) => {
      if (!error) {
        props.onSubmit(
          {
            newPassword: values.newPassword,
            oldPassword: values.currentPassword
          },
          isUpdatePasswordSuccessful => {
            setIsLoading(prev => !prev);
            handleResetForm(isUpdatePasswordSuccessful);
          }
        );
      } else {
        setIsLoading(prev => !prev);
      }
    });
  };

  const handleResetForm = isUpdatePasswordSuccessful => {
    isUpdatePasswordSuccessful && props.form.resetFields();
  };

  const handleConfirmPasswordBlur = e => {
    const { value } = e.target;
    setConfirmDirty(prevState => prevState || !!value);
  };

  const compareToNewPassword = (rule, value, callback) => {
    if (value && value !== props.form.getFieldValue("newPassword")) {
      callback("Ponovljena lozinka i lozinka ne mogu biti različite");
    } else {
      callback();
    }
  };

  const compareToConfirmPassword = (rule, value, callback) => {
    if (value && confirmDirty) {
      props.form.validateFields(["confirmPassword"], { force: true });
    }
    callback();
  };

  const validatePasswordLength = (rule, value, callback) => {
    if (value && value.length < passwordMinLength) {
      callback(
        "Lozinka mora biti najmanje {0} znakova".replace(
          "{0}",
          String(passwordMinLength)
        )
      );
    }
    callback();
  };

  const fields = useRef([
    {
      key: "currentPassword",
      label: "Stara lozinka",
      rules: [
        {
          required: true,
          message: "Unesite trenutnu lozinku"
        }
      ]
    },
    {
      key: "newPassword",
      label: "Lozinka",
      rules: [
        {
          required: true,
          message: "Unesite novu lozinku"
        },
        {
          validator: validatePasswordLength
        },
        {
          validator: compareToConfirmPassword
        }
      ]
    },
    {
      key: "confirmPassword",
      label: "Ponovi lozinku",
      rules: [
        {
          required: true,
          message: "Potvrdite novu lozinku"
        },
        {
          validator: compareToNewPassword
        }
      ],
      onBlur: handleConfirmPasswordBlur
    }
  ]);

  return (
    <LeftMenu activeKey={path}>
      <HelmetComponent
        title={`${"Lozinka"} | ${"INDEX OGLASI"}`}
        index={false}
      />

      <div className="page-title">{"Lozinka"}</div>
      <div className={styles.container}>
        <Form onSubmit={handleSubmit} className={styles.form}>
          {fields.current.map(item => (
            <Form.Item key={item.key} {...formItemLayout} label={item.label}>
              {getFieldDecorator(item.key, {
                rules: item.rules
              })(<Input type="password" onBlur={item.onBlur} size="large" />)}
            </Form.Item>
          ))}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              className={styles.submitButton}
            >
              {"Spremi promjene"}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </LeftMenu>
  );
};

export default requireUserLogin(
  submitFormData(Form.create()(ChangePassword), updatePassword)
);



// WEBPACK FOOTER //
// ./src/containers/ChangePassword/ChangePassword.tsx